import React, { useState } from "react";
import { use } from "react";
import { cache } from "react";
import { useNavigate } from "react-router-dom";
import { postData } from "../../services/NodeServices";









export default function ReturnOrder() {

const [returnOrderStep, setReturnOrderStep] = useState(1);
const [refund,setRefund] = useState('');


const orderId = new URLSearchParams(window.location.search).get('orderId');
const action = new URLSearchParams(window.location.search).get('action');

const questions = [
`recived damaged Product`,
`Order Size was incorrect`,
`Order was not as Described`,


]

const navigate = useNavigate();



const handleRequestCancel = async() => {




try{
  let body = {

    orderId:orderId,
    action:action,
    reason:'',
    refund:refund

  }
   

  const result = await postData('api/order/return-order',body)


    
  if(result.status){

  navigate('/cancel-success');

  }



}
catch(err){



}


}




return (

<>
<div className="cancel-order-cont">
 
 {returnOrderStep === 1 && <>
 <div className="cancel-order-step1">
    <div className="cancel-order-question">Why Would You Like to return Your Order?</div>
    <div className="order-cancel-questions">
        {questions.map((item)=>{


return(

<div className="cancel-question-item">
{item}
</div>

)


        })}

        <div className="order-cancel-button" onClick={()=>{setReturnOrderStep(2)}}>
        Continue
        </div>
    </div>


</div>
 
 </>}


 {returnOrderStep === 2 && <>
 
 <div className="returnorder-step2">
   <div className="return-order-question">Please provide more details about your return.</div>
   <textarea className="return-order-details" placeholder="Enter details here..."></textarea>
   <div className="return-order-button" onClick={() => { setReturnOrderStep(3) }}>
    Continue
   </div>
 </div>
 
 
 </>

 }

    {returnOrderStep === 3 && <>
    <div className="returnorder-step2">
      <div className="return-order-question">Please provide your UPI id to accept return</div>
       <input type="text" className="return-order-upi" onChange={(e)=>{setRefund(e.target.value)}} placeholder="Enter UPI ID here..." />

      <div className="return-order-button" onClick={handleRequestCancel}>
        Submit Return Request
      </div>
    </div>
  </>
    }

</div>
{<style>
{`

.cancel-order-cont {
width: 100%;
height: 100%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;

background-color: var(--bg-color);
font-family: var(--font-family);
font-size: var(--font-size);
color: var(--text-color);
border-radius: var(--border-radius);
box-shadow: var(--box-shadow);
min-height: 100vh;
height: 100vh;
width: 100vw;
overflow: hidden;
overflow-y: auto;
background-color: #f2f2f2;


}


.cancel-order-step1 {
 background-color: #fff;
 box-shadow: var(--box-shadow);
 min-width: 300px;
 min-height: 400px;
 width: 75%;
 border-radius:11px;



}

.cancel-order-question{
font-size: 1rem;
color: #444;
font-family: Poppins, sans-serif;
margin-top: 20px;
width: 100%;
display: flex;
justify-content: flex-start;
text-align: left;
margin-left: 20px;

}

.order-cancel-questions{
display:flex;
width:100%;
height:41px;
background-color:transparent;
flex-direction:column;
gap:11px;
padding:1rem 1.2rem;

}

.cancel-question-item{
border:1px solid rgba(119, 119, 119, 0.15);
font-family:'Poppins';
font-size:13px;
display:flex;
width:100%;
border-radius:5rem;
padding:1rem 1rem;
cursor:pointer;


}



.order-cancel-button{
display:flex;
background-color:rgb(22, 85, 26);
color:#fff;
padding:1rem 1rem;
justify-content:center;
border-radius:5rem;
font-family:'Poppins';
font-size:13px;
cursor:pointer;
}



.returnorder-step2{

 background-color: #fff;
 box-shadow: var(--box-shadow);
 min-width: 300px;
 min-height: 400px;
 width: 75%;
 border-radius:11px;


}

.return-order-question{
display:flex;
width:100%;
height:41px;
background-color:transparent;
flex-direction:column;
gap:11px;
padding:1rem 1.2rem;
font-family:'Poppins';
margin-top: 20px;
justify-content: flex-start;
text-align: left;
margin-left: 1rem;
}

.return-order-details{


}

.return-order-button{

display:flex;
background-color:rgb(22, 85, 26);
color:#fff;
padding:1rem 1rem;
justify-content:center;
border-radius:5rem;
font-family:'Poppins';
font-size:13px;
cursor:pointer;
margin: 1rem 2rem;
}

.return-order-details{
  display:flex;
  

  background-color:transparent;
  flex-direction:column;
  gap:11px;
  padding:1rem 1.2rem;
  font-family:'Poppins';
  margin-top: 20px;
  justify-content: flex-start;
  text-align: left;
  background-color: #f8f8f8;
  border: 1px solid #ccc;
  margin: 1rem 2rem;
  border-radius: 5px;
  min-height: 200px;
  font-family: 'Poppins';
  width: 93%;
}

.return-order-upi{
width: 93%;
height: 40px;
border: 1px solid #ccc;
border-radius: 5px;
padding: 0.5rem;
font-family: 'Poppins', sans-serif;
font-size: 1rem;
margin: 1rem 2rem;
}
`

}    
</style>}
</>


)





}